import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="approval"
// Prevents double-click on approval button and shows loading state
export default class extends Controller {
  static targets = ["button", "text", "spinner"]

  connect() {
    // Mark as not processing when controller connects
    this.isProcessing = false
  }

  handleClick(event) {
    // Prevent double-click - if already processing, prevent default and stop
    if (this.isProcessing) {
      event.preventDefault()
      event.stopPropagation()
      return false
    }

    // Mark as processing immediately
    this.isProcessing = true

    const button = this.buttonTarget || event.currentTarget.querySelector('button[type="submit"]')
    const text = this.textTarget
    const spinner = this.spinnerTarget

    // Disable button and show loading state immediately
    if (button) {
      button.disabled = true
      button.classList.add("opacity-50", "cursor-not-allowed")
    }

    if (text && spinner) {
      text.classList.add("hidden")
      spinner.classList.remove("hidden")
    }

    // Re-enable after 5 seconds as fallback (in case of errors)
    // This prevents the button from being stuck disabled forever
    setTimeout(() => {
      this.isProcessing = false
      if (button) {
        button.disabled = false
        button.classList.remove("opacity-50", "cursor-not-allowed")
      }
      if (text && spinner) {
        text.classList.remove("hidden")
        spinner.classList.add("hidden")
      }
    }, 5000)
  }
}

